import React from 'react';
import ClosableModal from './ClosableModal/ClosableModal';

export default function FileOverridePrompt({ fileName, open, onClose, onResolve }) {
  return (
    <ClosableModal
      className="d-flex flex-column justify-content-center align-items-center w-auto h-auto p-5"
      open={open}
      onClose={onClose}
    >
      <div className="align-self-center">
        <h3>
          File "<span>{fileName}</span>" already exists. Do you want to override it?
        </h3>

        <div className="d-flex justify-content-around">
          <button className="btn btn-primary" onClick={() => onResolve(false)}>
            Create New
          </button>

          <button className="btn btn-primary" onClick={() => onResolve(true)}>
            Override
          </button>
        </div>
      </div>
    </ClosableModal>
  );
}
